import { ApiPath } from 'common/enums/http/api-path';
import type { Report } from 'models/report';
import { http } from 'services/http';

export const getReportsApi = (params?: string) =>
  http.get<Report[]>(`${ApiPath.REPORTS}${params || ''}`);
